module.exports = __webpack_public_path__ + "img/icon_fb.e4d9681a.svg";